import { SnackbarProvider } from 'notistack'

const NotificationsProvider = ({ children, ...props }) => {
	return <SnackbarProvider {...props}>{children}</SnackbarProvider>
}

export { NotificationsProvider }
